<ion-app [ngClass]="{'isDevice': isDevice}">
  <ion-router-outlet></ion-router-outlet>
</ion-app>
